export default __webpack_public_path__ + "static/media/type_13_8.b5bd01e7.svg";